// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.ImportHistoryBarActions.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import { withHandlers } from 'recompose';
import { curry } from 'lodash/fp';

/**
 * Handle delete selected item
 * @param {Object} props
 * @param {Object} data
 */
function handleDelete(props: any, data: any) {
  const {
    store,
    store: {
      model,
      model: { historyFiles, pageIndex }
    }
  } = props;

  props
    .confirmFn('Information', {
      description: props.localization.getText('IMPORT_DELETE_SELECTED_MESSAGE'),
      type: 'warning',
      showCloseIndicator: false
    })
    .then(() => {
      store.deleteHistories().then(response => {
        const { success } = response;
        if (success) {
          // Check if delete all in page, return previous page
          if (historyFiles.length === model.getSelectedIds().length && pageIndex > 1) {
            model.updatePageIndex(pageIndex - 1);
          }
          props.loadHistories();
        }
        return Promise.resolve(success);
      });
    });
}

const actions = withHandlers({
  handleDelete: curry(handleDelete)
});

export default actions;



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/ImportHistory/ActionBar/Izenda.ImportHistoryBarActions.js